import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '寻访“重庆市制造业十大影响力年度人物暨专精特新中小企业优秀企业家”主题活动';
const baseUrl = '20241223ZZYPX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/rule`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'link',
      name: `${baseUrl}-news`,
      component: () => import('./pages/Link.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
